module.exports = __webpack_public_path__ + "img/bluedownarrow.4c3afb36.svg";